import { CustomTableHeader } from '../../../../../components/CustomTable';
import { renderStatusDot } from '../../../ProdutosDAF/Produtos/auxiliarProdutosDaf';

export const valoresOffcanvas: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorTipos: '',
  separadorObservacoes: '',

  //Específicos
  status: 'Status',
  nome: 'Domínio',
  descricao: 'Descrição',
  filhos: 'Domínios Filhos',
};

export type DominiosTableRow = {
  id: string | number;
  status: boolean;
  nome: string;
  descricao: boolean;
  filhos: string;
  [key: string]: any;
};

export const headersDominios: CustomTableHeader<DominiosTableRow>[] = [
  { text: '', width: 1, key: '', renderable: false },
  { text: 'ID', width: 3, key: 'id', fieldType: 'number', textAlign: 'center' },
  {
    text: 'Status',
    width: 4,
    key: 'status',
    renderCell: (value) => renderStatusDot(value),
    fieldType: 'checkbox',
    filterDefaultValue: 'true',
  },
  { text: 'Domínio', width: 10, key: 'nome' },
  { text: 'Descrição', width: 15, key: 'descricao' },
  { text: 'Domínios Filhos', width: 25, key: 'filhos' },
];

export const fieldObjectOrgInters = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
